import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import de from '../i18n/de.json';
import en from '../i18n/en.json';
import fr from '../i18n/fr.json';
import nl from '../i18n/nl.json';
import es from '../i18n/es.json';
import tr from '../i18n/tr.json';
export const resources = {
    de: {
        translation: Object.assign({}, de),
    },
    en: {
        translation: Object.assign({}, en),
    },
    fr: {
        translation: Object.assign({}, fr),
    },
    nl: {
        translation: Object.assign({}, nl),
    },
    es: {
        translation: Object.assign({}, es),
    },
    tr: {
        translation: Object.assign({}, tr),
    },
};
i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
    resources,
    fallbackLng: 'en',
    keySeparator: '.',
    interpolation: {
        escapeValue: false,
    },
});
export default i18n;
